<template>
  <div class="container">
    <my-header></my-header>
    <header-body></header-body>
    <bread v-if="!['/', '/login'].includes($route.path)" />
    <div class="main-content" :style="contentStyle">
      <div v-if="isCreatePage11" >
        <router-view v-if="isShow" :key="$route.fullPath"></router-view>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import MyHeader from '../components/MyHeader.vue'
import HeaderBody from '../components/HeaderBody.vue'
import MyFooter from '../components/MyFooter.vue'
import Bread from '../components/Bread.vue'
export default {
  name: 'IndexPage',
  components: { MyHeader, MyFooter, Bread, HeaderBody },
  data() {
    return {
      isShow: true,
      isCreatePage11: false,
    }
  },
  provide() {
    return {
      reload: this.reload,
    }
  },
  computed: {
    ...mapState(['isCreatePage']),
    contentStyle() {
      const { path } = this.$route
      return {
        minHeight: `calc( 100vh - 484px - 81px - ${path === '/' ? '510px' : '0px'})`,
      }
    },
  },
  methods: {
    reload() {
      this.isShow = false
      this.$nextTick(() => {
        this.isShow = true
      })
    },
  },
  watch: {
    isCreatePage(newV, oldV) {
      this.$nextTick(() => {
        this.isCreatePage11 = newV
      })
    },
    $route: {
      deep: true,
      handler(to, from) {
        this.$store.commit('setSearchObjects', [])
        this.reload()
      }
    },
  },
}
</script>
<style lang="less" scoped></style>
